import React from 'react';
import { StudyPlanTopic } from '@lf/ui-primitives';
function formatHours(hours) {
    if (hours == null || hours === '') return null;
    const n = Number(hours);
    if (!Number.isFinite(n) || n <= 0) return null;
    if (Number.isInteger(n)) return `${n}h`;
    return `${n.toFixed(1)}h`;
}

const SharePreview = ({ snapshot, snapshotTitle, sharerDisplayName, headerCta }) => {
    if (!snapshot) return null;

    const lessons = Array.isArray(snapshot.lessons) ? snapshot.lessons : [];
    const sharer = sharerDisplayName
        ? `Shared by ${sharerDisplayName}`
        : 'Shared by a Learnforest user';

    return (
        <div className="text-left mb-6">
            <div className="text-sm text-darkrock/60 mb-2">{sharer}</div>
            {headerCta && (
                <div className="mb-4">{headerCta}</div>
            )}
            <div className="flex items-center mb-2">
                <h1 className="text-2xl font-bold">
                    {snapshot.emoji ? `${snapshot.emoji} ` : ''}
                    {snapshot.subject || snapshotTitle || 'Shared study plan'}
                </h1>
            </div>
            {snapshot.goal && (
                <div className="text-lg mb-6">{snapshot.goal}</div>
            )}

            {lessons.map((lesson, lessonIndex) => {
                const hoursLabel = formatHours(lesson && lesson.lecture_hours);
                const isLast = lessonIndex === lessons.length - 1;
                const topics = Array.isArray(lesson && lesson.topics) ? lesson.topics : [];
                return (
                    <div
                        key={(lesson && lesson.id) || `lesson-${lessonIndex}`}
                        className="flex items-start mb-4 rounded-xl px-3 py-3">
                        <div className="mr-4 flex flex-col items-center">
                            <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold text-base leading-none bg-primary-600 text-white">
                                {lessonIndex + 1}
                            </div>
                            {!isLast && (
                                <div className="w-0.5 h-6 mt-1 bg-black/10" />
                            )}
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-center gap-2">
                                <div className="font-semibold text-darkrock">
                                    {lesson && lesson.title}
                                </div>
                                {hoursLabel && (
                                    <span className="text-darkrock/60 text-sm">· {hoursLabel}</span>
                                )}
                            </div>
                            {lesson && lesson.explanation && (
                                <div className="text-darkrock/80">{lesson.explanation}</div>
                            )}
                            {topics.map((topic, topicIndex) => (
                                <StudyPlanTopic
                                    key={(topic && topic.id) || `topic-${lessonIndex}-${topicIndex}`}
                                    topic={topic}
                                    index={topicIndex}
                                    isCurrent={false}
                                    isCompleted={false}
                                />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default SharePreview;
